<template>
  <section class="uc">
    
    <CodeSnippetLoader :filePath="`/snippets/${$i18n.locale}/${fileName}.html`" @clickBuy="clickBuy" />

    <ScenesView class="bg-[#f0f2f8]"></ScenesView>
    <SolutionsView @clickBuy="clickBuy" @clickCustomService="clickCustomService"></SolutionsView>
    
  </section>
</template>

<script>
import CodeSnippetLoader from './CodeSnippetLoader.vue';
import SolutionsView from "@/components/solutions-view.vue"
import ScenesView from "@/components/scenes-view.vue"

export default {
  name: 'UserCaseView',
  components: { CodeSnippetLoader, SolutionsView, ScenesView},

  data() {
    return {
      fileName: '',
    }
  },
  props: {
    
  },
  watch: {
    '$route.params.name'(newFile) {
        this.fileName = newFile;
    }
  },
  created() {
    this.fileName = this.$route.params?.name;
  },
  mounted() {
    this.initFadeInIntersectionObserver();
  },
  methods: {
    getImg(img) {
      return require(`@/assets/index/img/${img}`);
    },
    clickBuy() {
      this.$router.push({path: '/residential/'})
    },
    clickCustomService() {
        window.dispatchEvent(new CustomEvent('open-wechat-qr'));
    },
    async initFadeInIntersectionObserver() {
      const options = {
        threshold: 0.1
      };
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target;
            element.classList.add('fade-in-end');

            observer.unobserve(entry.target);
          }
        });
      }, options);

      this.$nextTick(() => {
        const elements = this.$el.querySelectorAll('.fade-in')
        elements.forEach(element => {
          observer.observe(element);
        });
      });
    },
  }
}
</script>

<style lang="scss">
.blue {
    color: #ec4899 !important
}

section.uc {
    color: #1c3b3b;
}

section.uc .case-banner-box {
    width: 100%;
    padding-top: 72px;
    padding-bottom: 136px;
    background-color: #f0f2f8;
    background: url("@/assets/index/img/application_scenario/scenario_bg.png") no-repeat center;
    background-size: auto
}

section.uc .case-banner-box .case-banner-content {
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center
}

section.uc .case-banner-box .case-banner-content .show-title {
    margin-top: 63px;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 25px;
    letter-spacing: 0px;
    color: #faa84b
}

section.uc .case-banner-box .case-banner-content .main-title {
    margin-top: 8px;
    font-family: "Poppins-Bold";
    font-size: 68px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 95px;
    letter-spacing: 0px;
    color: #223265
}

section.uc .case-banner-box .case-banner-content .explain-title {
    max-width: 778px;
    margin: 0 auto;
    margin-top: 16px;
    font-family: Poppins;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 25px;
    letter-spacing: 0px;
    color: #11182e
}

section.uc .case-banner-box .case-banner-content .get-into-btn {
    margin-top: 33px
}

section.uc .case-banner-box .case-banner-content .get-into-btn .btn {
    display: inline-block;
    width: 220px;
    height: 56px;
    background-color: #1c3b3b;
    border-radius: 4rem;
    font-family: Poppins;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 56px;
    letter-spacing: 0px;
    color: #ffffff
}

section.uc .case-banner-box .case-banner-content .get-into-btn .btn:hover {
    background-color: transparent;
    color: #1c3b3b;
    border: 1px solid #1c3b3b;
}

section.uc .case-box {
    width: 100%;
    margin: 0 auto;
    padding-top: 80px
}

section.uc .case-box .case-title-box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto
}

section.uc .case-box .case-title-box .title {
    font-family: "Poppins-Bold";
    font-size: 50px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 76px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-title-box .tips {
    font-family: Poppins;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 24px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-main-box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 80px
}

section.uc .case-box .case-main-box .case-main-title {
    text-align: left;
    font-family: "Poppins-Bold";
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-main-box .case-main-content {
    margin-top: 40px;
    display: flex;
    justify-content: flex-start
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-left {
    width: auto;
    max-width: 504px
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-left .case-main-content-title {
    margin-bottom: 10px;
    text-align: left;
    font-family: "Poppins-Bold";
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-left .case-main-content-text {
    font-family: Poppins;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-left .case-main-content-image {
    width: 100%;
    margin-top: 33px
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-left .case-main-content-image img {
    width: 100%
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-center {
    width: auto;
    max-width: 157px
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-center .case-main-content-image {
    width: 100%;
    height: 100%
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-center .case-main-content-image img {
    width: 100%;
    margin-top: 13px
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-center .case-main-content-image.seo-monitoring img {
    height: 67%
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-center .case-main-content-image.market-research img {
    height: 95%
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-center .case-main-content-image.web-scarping img {
    height: 92%
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-right {
    width: auto;
    max-width: 512px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-right .case-main-content-item {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    overflow: hidden
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-right .case-main-content-item .case-main-content-icon {
    margin-right: 13px;
    height: 26px;
    padding: 0 8px;
    border-radius: 13px;
    background-color: #02329b;
    font-family: Poppins;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 26px;
    letter-spacing: 0px;
    color: #ffffff
}

section.uc .case-box .case-main-box .case-main-content .case-main-content-right .case-main-content-item .case-main-content-text {
    width: auto;
    max-width: 473px;
    height: auto;
    text-align: left;
    font-family: Poppins;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-detail-box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 120px;
    padding-bottom: 121px
}

section.uc .case-box .case-detail-box .case-detail-title {
    max-width: 1090px;
    margin: 0 auto;
    font-family: "Poppins-Bold";
    font-size: 50px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 71px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-detail-box .case-detail-tip {
    max-width: 980px;
    margin: 0 auto;
    margin-top: 8px;
    margin-bottom: 80px;
    font-family: Poppins;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    text-align: center;
    line-height: 25px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-detail-box .case-detail-item {
    margin-top: 40px;
    text-align: left
}

section.uc .case-box .case-detail-box .case-detail-item .case-detail-item-title {
    font-family: "Poppins-Bold";
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-detail-box .case-detail-item .case-detail-item-tip {
    font-family: Poppins;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-detail-box .case-detail-item .case-detail-item-box {
    margin-top: 33px;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    justify-content: flex-start
}

section.uc .case-box .case-detail-box .case-detail-item .case-detail-item-box .case-detail-item-list {
    flex: 1;
    padding-bottom: 10px;
    background-color: #f0f2f9
}

section.uc .case-box .case-detail-box .case-detail-item .case-detail-item-box .case-detail-item-list .case-detail-item-list-title {
    height: 49px;
    padding-left: 40px;
    background-color: #dce4fa;
    font-family: Poppins;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 49px;
    letter-spacing: 0px;
    color: #272a36
}

section.uc .case-box .case-detail-box .case-detail-item .case-detail-item-box .case-detail-item-list .case-detail-item-list-box {
    padding-left: 40px;
    padding-top: 21px;
    padding-right: 40px;
    padding-bottom: 11px;
    background-color: rgba(240,242,249,0.5);
    font-family: Poppins;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #272a36
}
</style>
